import React, {Fragment} from 'react';
import {Settings, Icons, Popup} from 'components';
import {includes, toggle, openPopup, useNamedSelector} from 'helpers';
import {set} from 'store/settings';

export function SidebarPreferences({ module, ...props }) {
  const { group } = useNamedSelector('activities.preferences', { module });
  return (
    <Fragment>
      { props.isSidebar &&
        <Icons.Sort Sub={!/^(date|time)$/.test(group) && Icons.Bullet} title="Sort by" onClick={openPopup(SortSettings, {module})} />
      }
      <Icons.Settings title="Settings" onClick={openPopup(DisplaySettings, {module, ...props})} />
    </Fragment>
  );
}

function SortSettings({ module }) {
  const { group, hasCustomOrder, isRecurring } = useNamedSelector('activities.preferences', { module });
  return (
    <Fragment>
      <b>Sort by</b>
      <Popup.Menu>
        { isRecurring
          ? <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'time' })} checked={group == 'time'}>Time</Popup.Menu.Radio>
          : <Fragment>
            <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'date' })} checked={group == 'date'}>Newest first</Popup.Menu.Radio>
            <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'dateReverse' })} checked={group == 'dateReverse'}>Oldest first</Popup.Menu.Radio>
          </Fragment>
        }
        <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'goal' })} checked={group == 'goal'}>Goal</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'tags' })} checked={group == 'tags'}>Tags</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'priority' })} checked={group == 'priority'}>Priority</Popup.Menu.Radio>
        { hasCustomOrder &&
          <Popup.Menu.Radio onClick={() => set({ key: 'group', module, value: 'customOrder' })} checked={group == 'customOrder'}>Custom</Popup.Menu.Radio>
        }
      </Popup.Menu>
    </Fragment>
  );
}

function DisplaySettings({ module, isSidebar, shareStatus }) {
  const { status, isRecurring } = useNamedSelector('activities.preferences', { module });
  return (
    <Popup.Menu>
      <b>Display Options</b>
      <Popup.Menu.SubHeading>Activity status</Popup.Menu.SubHeading>
      <Popup.Menu.Checkbox onClick={() => set({ module, key: 'status', value: toggle(status, 'Not Started', { separator: ', ', min: 1 }) })} checked={includes(status, 'Not Started')}>{ isRecurring ? 'Active' : 'To Do' }</Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox onClick={() => set({ module, key: 'status', value: toggle(status, 'On Hold', { separator: ', ', min: 1 }) })} checked={includes(status, 'On Hold')}>On Hold</Popup.Menu.Checkbox>
      { isRecurring &&
        <Popup.Menu.Checkbox onClick={() => set({ module, key: 'status', value: toggle(status, 'Expired', { separator: ', ', min: 1 }) })} checked={includes(status, 'Expired')}>Expired</Popup.Menu.Checkbox>
      }
      { !isRecurring &&
        <Popup.Menu.Checkbox onClick={() => set({ module, key: 'status', value: toggle(status, 'Completed', { separator: ', ', min: 1 }) })} checked={includes(status, 'Completed')}>Completed</Popup.Menu.Checkbox>
      }
      { shareStatus &&
        <Settings.PopupShareStatus />
      }
      { isSidebar &&
        <Settings.PopupExternalCalendars />
      }
    </Popup.Menu>
  );
}
